import React, { Component } from 'react';
import { Menu } from 'antd';
import { connect } from 'react-redux';
import { canShowMenuItem, hasPermission, isAdmin } from '@/utils/permission';

const { SubMenu } = Menu;

class MenuGroupItem extends Component {

    render() {
        const { item, authUser, ...restProps } = this.props;

        if (item.isAdminOnly && !isAdmin(authUser)) return null;

        const displayedMenuItems = item.children.filter(child => {
            // Nếu menu con không có permission → hiển thị mặc định
            if (!child.permission) return true;

            // Nếu có action → kiểm tra đúng action
            if (child.action) {
                return hasPermission(authUser, child.permission, child.action);
            }

            // Nếu không có action → kiểm tra mặc định "list"
            return canShowMenuItem(authUser, child);
        });

        if (displayedMenuItems.length === 0) return null;

        return (
            <SubMenu title={item.name} key={item.path} icon={item.icon} {...restProps}>
                {displayedMenuItems.map(child => (
                    <Menu.Item key={child.path}>{child.name}</Menu.Item>
                ))}
            </SubMenu>
        );
    }
}

function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser,
        config: state.config
    };
}

export default connect(mapStateToProps)(MenuGroupItem);